import store from '../store'
import { i18n } from '@/i18n'
import Layout from '@/views/layout/Layout'
import SecondLayout from '@/views/layout/SecondLayout'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

export function beforeFun(to, from, next) {
  const roleType = store.state.user.userInfo.roleType
  if (to.name === 'aIPublishHomePage') { // 首页不做处理
    next()
  } else if (ROLE_TYPE_ENUM.AI_PUBLISH.code === roleType && !to.path.includes('/ai_publish')) { // AI发行用户不能进入数字音乐平台的页面
    next({ name: 'notExist' })
  } else {
    next()
  }
}

export default function() {
  return [
    {
      path: '/ai_publish',
      name: 'aIPublish',
      redirect: '/ai_publish/index',
      component: Layout,
      beforeEnter: beforeFun,
      isShow() {
        return false
      },
      children: [
        {
          path: 'person',
          name: 'aiPerson',
          meta: { title: i18n.t('nav.profile'), icon: 'user' },
          component: SecondLayout,
          redirect: '/ai_publish/person/home',
          isShow() {
            return true
          },
          children: [
            {
              path: 'home',
              name: 'aiPersonHome',
              isShow() {
                return true
              },
              component: () => import(/* webpackChunkName: "aiPersonHome" */ '@/views/person/aiPublish/personHome'),
              meta: { title: i18n.t('person.personHome'), icon: '' },
            },
            {
              path: 'index',
              name: 'aiPersonIndex',
              isShow() {
                return true
              },
              component: () => import(/* webpackChunkName: "aiPersonIndex" */ '@/views/person/aiPublish/index'),
              meta: { title: i18n.t('nav.basic'), icon: '' },

            },
            {
              path: 'notice',
              name: 'aiPersonNotice',
              isShow() {
                return true
              },
              meta: { title: i18n.t('nav.message'), icon: '' },
              component: () => import(/* webpackChunkName: "aiPersonNotice" */ '@/views/notice/index'),
            },
          ]
        },
        {
          path: 'ai_content',
          name: 'aiContent',
          meta: { title: i18n.t('aiContent.title'), icon: 'album' },
          component: SecondLayout,
          redirect: '/ai_publish/ai_content/track/list',
          isShow() {
            return true
          },
          children: [
            {
              path: 'track/list',
              name: 'aiTrackList',
              component: () => import(/* webpackChunkName: "aiTrackList" */ '@/views/aiTrack/list'),
              meta: { title: i18n.t('aiContent.trackManagement'), icon: '' },
              isShow() {
                return true
              }
            },
            {
              path: 'track/edit',
              name: 'aiTrackEdit',
              isShow() {
                return false
              },
              component: () => import(/* webpackChunkName: "aiTrackEdit" */ '@/views/aiTrack/edit'),
              meta: { title: '新建歌曲', icon: 'edit' }
            },
            {
              path: 'applyModify',
              name: 'aiApplyModify',
              redirect: '/ai_publish/ai_content/applyModify/song',
              meta: { title: i18n.t('aiContent.modifyRecord'), icon: '' },
              isShow() {
                return false
              },
              children: [
                {
                  path: 'song',
                  name: 'applyModifyAISong',
                  component: () => import(/* webpackChunkName: "applyModifyAISongList" */ '@/views/applyModifyAI/song'),
                  meta: { title: i18n.t('aiContent.modifyTrack'), icon: '' },
                  isShow() {
                    return true
                  }
                },
              ]
            }
          ]
        },
      ],
    },
  ]
}
